import {Map} from 'immutable'
import PropTypes from 'prop-types'

import BaseRequestItemPermissionsModal from '../shared/BaseRequestItemPermissionsModal'
import Logger from '../../../../../lib/NewLogger'
import {requestedItemPermissions} from '../../../../../lib/itemPermissionTools'

const FirmUserRequestItemPermissionsModal = ({
  firmUserConfig,
  updateResource,
  ...props
}) => {
  const handleSaveDefaultSettings = checkedItemIds => {
    Logger.log({name: 'advisor_saved_default_item_permissions'})

    updateResource({
      type: 'firm-user-configs',
      id: firmUserConfig.get('id'),
      attributes: {
        'default-item-permissions': requestedItemPermissions({
          itemIds: checkedItemIds,
          permissionType: 'edit'
        })
      }
    })
  }

  return (
    <BaseRequestItemPermissionsModal
      {...props}
      showDefaultSettings
      onSaveDefaultSettings={handleSaveDefaultSettings}
    />
  )
}

FirmUserRequestItemPermissionsModal.propTypes = {
  ...BaseRequestItemPermissionsModal.propTypes,
  firmUserConfig: PropTypes.instanceOf(Map).isRequired,
  updateResource: PropTypes.func.isRequired
}

export default FirmUserRequestItemPermissionsModal
